var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33546 2.00873C4.42084 1.66286 4.91254 1.66286 4.99793 2.00873V2.00873C5.36241 3.48511 6.51517 4.63784 7.99155 5.0023V5.0023C8.33744 5.08768 8.33744 5.57939 7.99155 5.66478V5.66478C6.51517 6.02924 5.36241 7.18196 4.99793 8.65834V8.65834C4.91254 9.00422 4.42084 9.00422 4.33546 8.65834V8.65834C3.97097 7.18196 2.81822 6.02924 1.34183 5.66478V5.66478C0.995945 5.57939 0.995945 5.08768 1.34183 5.0023V5.0023C2.81822 4.63784 3.97097 3.48511 4.33546 2.00873V2.00873Z",
    fill: "url(#paint0_linear_2_2379)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97724 0.543073C8.0118 0.403075 8.21082 0.403075 8.24538 0.543073V0.543073C8.39291 1.14065 8.8595 1.60724 9.45709 1.75475V1.75475C9.59709 1.78931 9.59709 1.98834 9.45709 2.0229V2.0229C8.8595 2.17042 8.39291 2.637 8.24538 3.23458V3.23458C8.21082 3.37458 8.0118 3.37458 7.97724 3.23458V3.23458C7.82971 2.637 7.36312 2.17042 6.76553 2.0229V2.0229C6.62553 1.98834 6.62553 1.78931 6.76553 1.75475V1.75475C7.36312 1.60724 7.82971 1.14065 7.97724 0.543073V0.543073Z",
    fill: "url(#paint1_linear_2_2379)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2379",
    x1: 4.66669,
    y1: 0.667023,
    x2: 4.66669,
    y2: 10.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45185A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2379",
    x1: 8.11131,
    y1: 0,
    x2: 8.11131,
    y2: 3.77765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45185A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconFilled);
export default __webpack_public_path__ + "static/media/AiIconFilled.01e7c9668844f61d157fdd341a2e6cd2.svg";
export { ForwardRef as ReactComponent };